import React from "react";

import { formatRupiah } from "../../../helper/formatNumber";

import "./salesYearly.css";

const SalesYearly = ({ transactionDate, transactionData }) => {
  return (
    <div className="sales-yearly-container">
      <h4>Transaksi pada {transactionDate}</h4>
      <div className="sales-yearly-table-container">
        {transactionData.map((data, index) => (
          <div className="sales-yearly-row" key={index}>
            <p className="sales-yearly-column">{data.month}</p>
            <p className="sales-yearly-column">
              <b>{formatRupiah(data.total_transaction)}</b>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesYearly;
